<template>
  <v-content>
    <div class="staticHero">
      <v-img src="../assets/images/img14.jpg">
        <v-row align="end" class="lightbox white--text pa-2 fill-height">
          <v-col>
            <v-container>
              <div class="headline">Contact Us</div>
            </v-container>
          </v-col>
        </v-row>
      </v-img>
    </div>
    <div class="block">
      <v-container>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-text-field persistent-hint outlined v-model="msgInfo.name" :counter="20" :rules="nameRules" label="Name"
            required></v-text-field>
          <v-text-field label="Phone No" :rules="[v => !!v || 'Phone number is required']" persistent-hint outlined
            v-model="msgInfo.phone"></v-text-field>
          <v-text-field persistent-hint outlined v-model="msgInfo.email" :rules="emailRules" label="E-mail"
            required></v-text-field>
          <v-textarea label="Message"
            :rules="[v => (v && v.length <= 200) || 'Message is required and 200 characters or less']" persistent-hint
            outlined v-model="msgInfo.message"></v-textarea>
          <v-btn :disabled="!valid" color="success" class="mr-4" @click="submitMsg">Submit</v-btn>
          <v-btn color="error" class="mr-4" @click="reset">Reset</v-btn>
        </v-form>
      </v-container>
    </div>
    <div class="block">
      <v-container>
        <h4>Contact info.</h4>
        <v-form>
          <v-icon left>fas fa-phone</v-icon>
          <a href="tel:9052093588"> 905-209-3588 </a>
          <br />
          <v-icon left>fas fa-phone</v-icon>
          <a href="tel:9052093288"> 905-209-3288 </a>
          <br />
          <v-icon left>fas fa-envelope</v-icon>
          <a href="mailto:info@jhykitchen.ca"> info@jhykitchen.ca </a>
          <br />
          <v-icon left>fas fa-map-marker-alt</v-icon>
          144 Bullock Drive, Markham ON L3P 1W2
          <br />
          <h4 style="display:inline;">Store Hours:</h4> <br />Monday - Saturday: 9:30am-6:00pm
          <br />Sunday: By appointment.
        </v-form>
      </v-container>
    </div>
    <div class="googlemap">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2875.943892717787!2d-79.27432802331435!3d43.87771407109233!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89d4d614f50a4d4b%3A0x104f27e62b1a714c!2s144%20Bullock%20Dr%2C%20Markham%2C%20ON%20L3P%201W2!5e0!3m2!1sen!2sca!4v1685852939835!5m2!1sen!2sca"
        width="100%" height="450"></iframe>

    </div>
  </v-content>
</template>

<script>
import MessageService from '@/services/MessageService'
import axios from 'axios'
export default {
  name: "Contact",
  data: () => ({
    valid: true,
    msgInfo: {},
    name: "",
    nameRules: [
      v => !!v || "Name is required",
      v => (v && v.length <= 20) || "Name must be less than 20 characters"
    ],
    email: "",
    emailRules: [
      v => !!v || "E-mail is required",
      v => /.+@.+\..+/.test(v) || "E-mail must be valid"
    ],
    message: "",
    messageRules: [
      v => !!v || "Message is required",
      v => (v && v.length >= 10) || "Message must be more than 10 characters"
    ],
  }),
  mounted() {
    axios
      .get('https://api.ipify.org?format=json')
      .then(response => {
        // alert('get IP :'+response.data.ip)
        this.msgInfo.ipInfo = response.data.ip
      })
      .catch(error => {
        alert('get IP error:'+error)
      })
  },
  methods: {
    async submitMsg() {
      this.valid = this.$refs.form.validate()
      if (!this.valid) {
        return
      }

      try {
        const response = await MessageService.post(this.msgInfo)
        if (response) {
          alert('Your message was successfully submitted.')
          this.msgInfo = {}
          this.$refs.form.resetValidation()
        }
      } catch (error) {
        this.error = error.response.data.error
      }
    },
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>